import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Container } from "react-bootstrap";

class MainPageContainer extends Component {
  constructor() {
    super();
    this.state = {
    };
  }
  render() {
    return (
      <Container>
        {this.props.children}
      </Container>
    );
  }
}

MainPageContainer.propTypes = {
  children: PropTypes.any.isRequired
};

export default MainPageContainer;
